module.exports = __webpack_public_path__ + "img/CB.dc0931b7.svg";